import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.6665 3.33301H3.33317C2.4127 3.33301 1.6665 4.0792 1.6665 4.99967V14.9997C1.6665 15.9201 2.4127 16.6663 3.33317 16.6663H16.6665C17.587 16.6663 18.3332 15.9201 18.3332 14.9997V4.99967C18.3332 4.0792 17.587 3.33301 16.6665 3.33301Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.3332 5.83301L10.8582 10.583C10.6009 10.7442 10.3034 10.8297 9.99984 10.8297C9.69624 10.8297 9.39878 10.7442 9.1415 10.583L1.6665 5.83301",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEmail;
